import { render, staticRenderFns } from "./input-comment.vue?vue&type=template&id=e6358b1a&scoped=true&"
import script from "./input-comment.vue?vue&type=script&lang=js&"
export * from "./input-comment.vue?vue&type=script&lang=js&"
import style0 from "./input-comment.vue?vue&type=style&index=0&id=e6358b1a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6358b1a",
  null
  
)

export default component.exports